<template>
  <BasePage :page-title="__DICT__.actionMenu.liftPass" back-button show-menu>
    <!-- Loading State -->
    <LoadingSpinner v-if="loading" />

    <!-- Main Content -->
    <div v-else class="d-flex flex-column" style="min-height: calc(100vh - 300px)">
      <Card title="Distribution Locations">
        <div class="list-group list-group-flush">
          <span></span>
          <span v-for="location in liftPassLocations"
                :key="location">
            <!-- eslint-disable-next-line @intlify/vue-i18n/no-raw-text -->
            <span @click="linkToLocation(location, time)" class="list-group-item list-group-item-action d-flex align-items-center justify-content-between" v-for="time in location.times">
              {{ location.distributionPoint }} - {{time.allocationDistributionTime }} ({{time.tickets}})
            </span>
          </span>
        </div>
      </Card>
    </div>
  </BasePage>
</template>

<script setup>
import {ref, computed, onMounted, onUnmounted} from "vue";
import { useWeekStore } from '@/stores/week.js'
import { usePermissions } from '@/composables/usePermissions'
import { api } from "@/services/api.js";
import { encodeObjectToBase64Url } from "@/services/base64.js";
import BasePage from "@/components/BasePage.vue";
import { Card, LoadingSpinner } from "@/components/atomic";
import {useRouter} from "vue-router";

// State Management
const weekStore = useWeekStore()
const { can } = usePermissions()
const loading = ref(true)
const liftPassLocations = ref([])
const router = useRouter()


const linkToLocation = (location,time) => {
    const encoded = encodeObjectToBase64Url({location: location.distributionPoint, time: time.allocationDistributionTime});
    router.push(`/liftPassDistribution/${encoded}`)
}


const refreshData = async () => {
  const response = await api.get(`/api/scanLiftPass/allBarcodes/${weekStore.weekId}`);
  //const repId = weekStore.repObj.repId;

  const passLocations = []
  const tickets = response?.tickets || []
  tickets.forEach(p => {
    let i = passLocations.findIndex(pl => pl.distributionPoint === p.distributionPoint)

    if(i === -1){
      passLocations.push({distributionPoint: p.distributionPoint, times: [{allocationDistributionTime: p.allocationDistributionTime, tickets: 1}]})
    } else {
      let j = passLocations[i].times.findIndex(t => t.allocationDistributionTime === p.allocationDistributionTime)
      if(j === -1) {
        passLocations[i].times.push({allocationDistributionTime: p.allocationDistributionTime, tickets: 1})
      } else {
        passLocations[i].times[j].tickets = passLocations[i].times[j].tickets + 1
      }

    }
  })
  // Level 3 non-snowfuze users can see all locations
  if (can('viewAllLiftPasses')) {
    passLocations.push({distributionPoint: 'All', times: [{allocationDistributionTime: 'All', tickets: tickets.length}]})
  }
  liftPassLocations.value = passLocations
};


onMounted(async () => {
  try {
    await refreshData();
  } finally {
    loading.value = false;
  }
})

</script>
